<template>
    <component
        :is="isInner ? 'router-link' : 'a'"
        :to="isInner ? path: ''"
        :href="!isInner ? outer + path: ''">
        <slot></slot>
    </component>
</template>


<script>
export default {
    props: {
        path: {
            require: true,
        }
    },
    computed: {
        isInner() {
            if (this.$store.state.subdomain) {
                return false;
            }
            return true;
        },
        outer() {
            return "//www" + this.$store.state.base_domain;
        }
    },
}
</script>